import { cur } from './units';
import { jsPDF } from 'jspdf';
import { tsHead } from './timesheet';
import { APP_INFO } from './license';

const num = (v, t) => (typeof v === 'number' ? v.toLocaleString(t.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v);

// signed monthly timesheet of one staff member (A4 landscape) -> Blob
export function timesheetPdf(t, month, sh, sig) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const W = 297, M = 10, cols = [20, 30, 30, 28, 18, 13, 13, 13, 13, 13, 13, 13, 13, 14, 11, 16], head = tsHead(t);
  let y = 14;
  doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text(`${t.tzTitle} ${month}`, M, y);
  doc.setFontSize(11); doc.text(`${sh.s.name}${sh.s.role ? ` – ${sh.s.role}` : ''}`, M, (y += 7));
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
  doc.text(`${APP_INFO.name} · ${new Date().toLocaleString(t.locale)}`, W - M, 14, { align: 'right' });
  y += 6;
  const row = (cells, bold, fill) => {
    const lines = cells.map((c, i) => doc.splitTextToSize(String(num(c, t) ?? ''), cols[i] - 1.5));
    const h = Math.max(...lines.map((l) => l.length)) * 3.4 + 2;
    if (y + h > 150) { doc.addPage(); y = 14; }
    if (fill) { doc.setFillColor(...fill); doc.rect(M, y, W - 2 * M, h, 'F'); }
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    let x = M;
    lines.forEach((l, i) => { doc.text(l, x + 0.8, y + 3.6); x += cols[i]; });
    doc.setDrawColor(210); doc.line(M, y + h, W - M, y + h);
    y += h;
  };
  doc.setFontSize(7.5);
  row(head, true, [226, 232, 240]);
  sh.rows.forEach((r) => row(r));
  row([t.wlSum, '', '', '', '', '', '', '', '', '', '', sh.work, sh.travel, sh.tot, sh.rate || '', sh.cost], true, [241, 245, 249]);
  if (y > 150) { doc.addPage(); y = 14; }
  y += 8;
  doc.setFontSize(9); doc.setFont('helvetica', 'normal');
  doc.text(`${t.tzDays}: ${sh.days} · ${t.wlWork}: ${num(sh.work, t)} h · ${t.wlTravel}: ${num(sh.travel, t)} h · ${t.wlSum}: ${num(sh.tot, t)} h${sh.cost !== '' ? ` · ${num(sh.cost, t)} ${cur()}` : ''}`, M, y);
  y += 8;
  const box = (x, label, s) => {
    doc.setDrawColor(120); doc.line(x, y + 24, x + 110, y + 24);
    if (s?.data) {
      const p = doc.getImageProperties(s.data), k = Math.min(60 / p.width, 22 / p.height);
      doc.addImage(s.data, p.fileType || 'JPEG', x, y + 22 - p.height * k, p.width * k, p.height * k, undefined, 'FAST');
    }
    doc.setFontSize(8);
    doc.text(`${label}${s?.name ? `: ${s.name}` : ''}`, x, y + 28);
    if (s?.at) doc.text(new Date(s.at).toLocaleString(t.locale), x, y + 32);
  };
  box(M, t.tzSigStaff, { ...sig.staff, name: sh.s.name });
  box(W / 2 + 5, t.tzSigBoss, sig.boss);
  return doc.output('blob');
}
